let contactbtn = $('.contact__button button')

$('#ContactForm').on('input',function(e){

var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
var name = $('#ContactForm-name').val();
var email = $('#ContactForm-email').val();
var message = $('#ContactForm-body').val();

    if(name != '' && email != '' && email.match(validRegex) && message != '') {
        contactbtn.addClass('ready-to-submit');
    }
    else {
        contactbtn.removeClass('ready-to-submit');
    }
    
});